import type { ContentObjectListDataObject } from '../service';
import {
  type ActivityContentObjectList,
  type CommentContentObjectList,
  type EventContentObjectList,
  type GivingContentObjectList,
  type KudoContentObjectList,
  type PollContentObjectList,
  type PostContentObjectList,
  type VideoContentObjectList,
  type WithingsOrderPostContentObjectList,
  createActivityContentObjectList,
  createCommentContentObjectList,
  createEventContentObjectList,
  createGivingContentObjectList,
  createKudoContentObjectList,
  createPollContentObjectList,
  createPostContentObjectList,
  createVideoContentObjectList,
  createWithingsOrderPostContentObjectList,
} from './entity-type-content-objects';

export type ContentObjectList =
  | ActivityContentObjectList
  | CommentContentObjectList
  | EventContentObjectList
  | GivingContentObjectList
  | KudoContentObjectList
  | PollContentObjectList
  | PostContentObjectList
  | VideoContentObjectList
  | WithingsOrderPostContentObjectList;

export const createContentObjectList = (data: ContentObjectListDataObject): ContentObjectList => {
  switch (data.type) {
    case 'activity':
      return createActivityContentObjectList(data);
    case 'comment':
      return createCommentContentObjectList(data);
    case 'event':
      return createEventContentObjectList(data);
    case 'giving':
      return createGivingContentObjectList(data);
    case 'kudo':
      return createKudoContentObjectList(data);
    case 'poll':
      return createPollContentObjectList(data);
    case 'post':
      return createPostContentObjectList(data);
    case 'video':
      return createVideoContentObjectList(data);
    case 'withings_order_post':
      return createWithingsOrderPostContentObjectList(data);
  }
};
